<script setup lang="ts">

</script>

<template>
  <div class="flex-center rd-8px bg-#fff c-#1F1E3D99">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
</style>
